/* eslint-disable vue/no-use-v-if-with-v-for */
<template>
  <div class="">
        <table class="table table-hover table-dark">
            <thead>
              <tr>
                <th scope="col" style="margin-left: -10px;">Machine</th>
                <th scope="col" style="margin-left: -10px;">Machine<br>Status</th>
                <th scope="col" style="margin-left: -10px;">Current<br>Product</th>
                <th scope="col" style="margin-left: -10px;">Meters/<br>Minute</th>
                <th scope="col" style="margin-left: -10px;">Thresh</th>
                <th scope="col" style="margin-left: -10px;">Sensor<br>Status</th>
                <th scope="col" style="margin-left: -10px;" v-if="userType != 'viewer'">View</th>
              </tr>
            </thead>
            <tbody>
              <tr 
                v-for="machine in corrugatorss" 
                :key="machine.id" 
                id="machine_row" 
                class="machine_status"
                :class="statusFomart(machine)"
                v-if="userType === 'Super Admin' || machine.machine_state !== 'DevStatus'">
                <td class="machine_name" style="margin-left: -10px;">{{ machine.machineName }}</td>
                <!--MACHINE STATUS -->
                <td>
                  <select 
                    :disabled="disabled"
                    :class="statusFomart(machine)"
                    v-model="machine.machine_state" 
                    @change="machine_config(machine)" >
                    <option disabled selected>{{ machine.machine_state  }}</option>
                    <option v-for="status in machine_status" :key="status.id">{{ status.name }}</option>
                  </select>
                </td>
                <!--METERS PER MIUTE -->
                <td>
                  <select 
                    :class="statusFomart(machine)"
                    v-model="machine.product" 
                    :disabled="disabled"
                    @change="product_config(machine)" >
                    <option disabled selected>{{ machine.product  }}</option>
                    <option v-for="product in products" :key="product.id">{{ product.name }}</option>
                  </select>
                </td>
                <!--METERS PER MIUTE -->
                <td style="margin-left: -10px;" 
                v-if="parseFloat((machine['deltaPulses' + machine.MonitorInput] / machine.pulseConfig) / (machine['differenceInSeconds' + machine.MonitorInput] / 60)).toFixed(2) < 0
                ||
                !sensorOn(machine)">0.00</td><!-- TIME MORE THAN COMM INTERVAL -->
                <td 
                style="margin-left: -10px;" 
                v-else>
                    {{
                       (Number(machine.pulseConfig) > 0 && Number(machine.differenceInSeconds5) > 0)
                      ? ((Number(machine['deltaPulses' + machine.MonitorInput]) / Number(machine.pulseConfig)) / (Number(machine['differenceInSeconds' + machine.MonitorInput]) / 60)).toFixed(2)
                      : '0.00'
                  }}
              </td> 
              <!-- TIME LESS THAN COMM INTERVAL-->
                <!--BELOW THRESH -->
                <td style="margin-left: -10px;">{{ machine.threshold }}</td>
                <!--STATUS -->
                <td style="margin-left: -10px;" v-if="sensorOn(machine)">On</td>
                <td style="margin-left: -10px;" v-else>Off</td>
                <td>
                <i class="fa fa-eye" @click="corrugatorChart(machine.machineName)" v-if="userType != 'viewer'"></i>
                </td>
              </tr>
            </tbody>
          </table>
     </div>
</template>
<script>
import axios from 'axios'
import http from '../../../services/http'
export default {
  data() {
  return {
    mechines: [],
    corrugators: [],
    DeviceId: '',
    firtRaw: '',
    secondRaw: '',
    compare: '',
    meterPerMin: '',
    machineStatus: 1,
    sensorStatus: '',
    interval: null,
    machine_status: [],
    userType: '',
    disabled: false
    }
  },

computed: {
  corrugatorss() {
    return this.$store.state.machines.corrugator
  },

  products() {
    return this.$store.state.products.corrugatorProduct
  }
  
},

mounted() {
  this.allstatus()
  this.userType = localStorage.getItem('userType')
  if(this.userType == 'viewer')
  {
    this.disabled = true
  }
},

methods: {
    //GET USER DETAILS
getUserDetails() {
  let userDetails = localStorage.getItem('userType')
  this.userType = userDetails
},

// Sensor is ON if the device reported within comm_interval SECONDS.
// comm_interval is stored in seconds (DowntimeAlerts.php divides it by 60 for
// minutes). updatedDate is naive UTC, so it must be given an explicit zone —
// otherwise the browser reads it as local SAST and every machine looks 2h stale.
sensorOn(machine) {
  if (!machine || !machine.updatedDate) return false
  const last = new Date(String(machine.updatedDate).replace(' ', 'T') + 'Z').getTime()
  if (isNaN(last)) return false
  return (Date.now() - last) / 1000 < Number(machine.comm_interval)
},

statusFomart(machine) {
  let oldDateTime = new Date(machine.updatedDate + 'Z');
  let currentTime = new Date();
  currentTime = currentTime.getTime();
  oldDateTime = oldDateTime.getTime();
  var threshhold_status = (machine['deltaPulses' + machine.MonitorInput] / machine.pulseConfig / (machine['differenceInSeconds' + machine.MonitorInput] / 60)) >= machine.threshold

  let On;
  let machineOn;
  let Of

  if((currentTime / 1000) - (oldDateTime / 1000) < machine.comm_interval && threshhold_status == true) 
  {
    On = true
  }
  if((currentTime / 1000) - (oldDateTime / 1000) > machine.comm_interval) 
  {
    On = false
  } else if(machine.status == 0 && (currentTime / 1000) - (oldDateTime / 1000) > machine.comm_interval) {
    Of = true
  }else if (machine.status == 0 || threshhold_status == false && (currentTime / 1000) - (oldDateTime / 1000) < machine.comm_interval){
    machineOn = true
  }
  return {
    yellow: machineOn,
    danger: !On,
    success: On,
    Off: Of
  }
},

  corrugatorChart(machineName) 
    {
     this.$router.push('/ExtruderCharts/' + machineName)
    },

product_config(machine) {
        let formData = new FormData()
        let action = 'productUpdate'
        let fullname  = localStorage.getItem('fullname')
        let description = fullname+" Changed product for " +  machine.machineName + " to " + machine.product

        formData.append('action', action);
        formData.append('fullname', fullname)
        formData.append('description', description)
        formData.append('action', action);
        formData.append('machine_name', machine.machineName)
        formData.append('product', machine.product)
        http.patch('/api/machines/product', {
          machine_name: machine.machineName,
          product: machine.product,
        })
          .then(() => {
            return this.$store.state.machines.corrugators
          })
      },
      
      machine_config(machine) {
        let formData = new FormData()
        let action = 'statusUpdate'
        let fullname  = localStorage.getItem('fullname')
        let description = fullname+" Changed " +  machine.machineName + " state to " + machine.machine_state

        formData.append('action', action);
        formData.append('fullname', fullname)
        formData.append('description', description)
        formData.append('action', action);
        formData.append('machine_name', machine.machineName)
        formData.append('machine_state', machine.machine_state)
        http.patch('/api/machines/state', {
          machine_name: machine.machineName,
          machine_state: machine.machine_state,
        })
          .then(() => {
            // this.closeModal()
            return this.$store.state.machines.extruders
          })
      },     
      
 //SELECT ALL STATUS
  allstatus() {
       http.get('/api/machine-states')
          .then((res) => {
            this.machine_status = res.data
          })
          .catch(function (error) {
              console.log(error)
          })
      }
 },
}
</script>
<style scoped>
tbody tr:hover,
tbody tr:active {
  background-color: #A9A9A9;
}

.Off {
  background-color: red;
  color: white;
  }

.machine_status._0 {
  background-color: orange;
  color: #fff;
  }

.machine_status._1 {
  background-color: green;
  color: #fff;
  }

.On {
  background-color: green;
  color: white;
  }

tr {
   line-height: 15px;
   min-height: 15px;
   height: 15px;
   word-wrap: break-word;
   width: 10px;
}

.success {
  background-color: green;
}

.danger {
  background-color: red;
}

.yellow {
  background-color: orange;
}

.threshold {
  background-color: orange;
}

select {
   min-height: 10px;
   height: 15px;
   word-wrap: break-word;
   max-width: 80%;
   color: white;
   border: none;
}

</style>